import React, { useEffect, useState } from 'react';
import Pagination from "components/Common/Pagination"
import SearchBox from "components/Common/SearchBox"
import {
    getPublicPolicies,
    getPublicPolicyDownloadInterestGroups, getPublicPolicyDownloadReasons,
    savePolicyView
} from "services/policyDirectoryServices"
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    Input,
    Label,
    Form,
    FormGroup,
} from "reactstrap"
import { GET_PUBLIC_POLICY_URL } from "../../services/CONSTANTS";
import ExportTable from "../../components/Common/ExportTable";
import { exportTableData } from "services/common"
import PublicPolicyDirectoryFilters from './PublicPolicyDirectoryFilters';
import { areObjectsEqual } from "helpers/utlities"
import LoadingSpinner from 'components/Common/Loading-Spinner';
import PolicyChatbot from 'components/PolicyChatbot/PolicyChatbot';

export default function HomePolicies({ alert }) {
    // Pagination
    const [offset, setOffset] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalEntries, setTotalEntries] = useState(0)
    const [loading, setLoading] = useState(false)
    
    const handlePageChange = pageNum => {
        const offsetVal = pageNum * 50 - 50
        setOffset(offsetVal)
        setCurrentPage(pageNum)
    }
    
    const [modalReason, setModalReason] = useState(false);
    const [downloadingPolicy, setDownloadingPolicy] = useState(null);
    const [policyPreview, setPolicyPreview] = useState(null);
    const [modalPreview, setModalPreview] = useState(false);
    const [data, setData] = useState([]);
    const [interestGroups, setInterestGroups] = useState([]);
    const [reasons, setReasons] = useState([]);
    const [intention, setIntention] = useState({
        interest_group_id: null,
        reason_id: null,
    });

    const togglePreviewModal = () => setModalPreview(!modalPreview);

    const loadData = async () => {
        const limit = 50;
        setLoading(true);
        try {
            const query = {
                limit,
                offset,
                searchTerm,
                ...appliedFilters
            };
            const { data, count } = await getPublicPolicies(query);
            setData(data);
            setTotalEntries(count);
        } catch (err) {
            console.error(err);
            alert("Loading policy data", false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const groups = await getPublicPolicyDownloadInterestGroups();
                const reasons = await getPublicPolicyDownloadReasons();
                setInterestGroups(groups);
                setReasons(reasons);
            } catch (err) {
                console.error("Error fetching dropdown data:", err);
                alert("Loading dropdown data", false);
            }
        };
        fetchDropdownData();
    }, []);

    const requestDownloadFileUrl = async () => {
        try {
            const url = GET_PUBLIC_POLICY_URL(downloadingPolicy);
            window.open(url, "_blank");
        } catch (err) {
            console.error(err);
            alert("Downloading policy file", false);
        }
    }

    const saveReasonsAndDownload = async () => {
        if (!intention.interest_group_id || !intention.reason_id) {
            alert("Please select both Interest Group and Reason before downloading.", false);
            return;
        }

        try {
            await savePolicyView(downloadingPolicy, {
                interest_group_id: parseInt(intention.interest_group_id),
                reason_id: parseInt(intention.reason_id),
            });

            setModalReason(false);
            setIntention({ interest_group_id: null, reason_id: null });
            requestDownloadFileUrl();
        } catch (err) {
            console.error("Error saving policy view:", err);
            alert("Download request", false);
        }
    };

    // Search handling
    const [searchTerm, setSearchTerm] = useState("")

    const handleSearchInputChange = evt => {
        setSearchTerm(evt.target.value);
        setOffset(0);
        setCurrentPage(1);
    }

    // Filters
    const initialFiltersState = {
        locations: [],
        systems: [],
    }
    
    const [appliedFilters, setAppliedFilters] = useState(initialFiltersState);
    const [modalFilter, setModalFilter] = useState(false)
    
    const toggleModalFilter = () => setModalFilter(prevState => !prevState)

    const applyFilters = (filters) => {
        setAppliedFilters(filters);
        setCurrentPage(1);
        setOffset(0);
        toggleModalFilter();
    }

    const areAnyFiltersSelected = () => !areObjectsEqual(appliedFilters, initialFiltersState);
    
    const clearFilters = () => {
        setAppliedFilters(initialFiltersState);
        setCurrentPage(1);
        setOffset(0);
    }

    const exportTable = async (type) => {
        try {
            const query = {
                export_format: type,
                searchTerm,
                ...appliedFilters
            };

            exportTableData(query, "Policies_Public");
        } catch (err) {
            console.error(err);
            alert("Data export", false);
        }
    }

    useEffect(() => {
        loadData();
    }, [currentPage, searchTerm, appliedFilters]);

    return (
        <div className="w-full md:w-11/12 mx-auto my-4 px-4 md:px-0">
            <div className="flex flex-col md:flex-row md:justify-between md:items-center my-3">
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                    <SearchBox searchChange={handleSearchInputChange} />
                    <div className="flex justify-around">
                        <button
                            className="common-button"
                            onClick={toggleModalFilter}
                        >
                            <i className="mdi mdi-filter-variant me-1" /> Filters
                        </button>
                        {areAnyFiltersSelected() ? (
                            <Button
                                className="common-outlined-button"
                                onClick={clearFilters}
                            >
                                <i className="ph-x me-1"></i>
                                Clear All Filters
                            </Button>
                        ) : null}
                        </div>
                </div>
                <div className="flex justify-end">
                    <ExportTable loadFilteredData={exportTable} />
                </div>
            </div>
            
            {/* Filter Modal */}
            <Modal
                isOpen={modalFilter}
                toggle={toggleModalFilter}
                className="modal-dialog-centered modal-lg"
            >
                <ModalHeader toggle={toggleModalFilter}>
                    <i className="mdi mdi-filter-variant me-1"></i>
                    Filters
                </ModalHeader>
                <ModalBody>
                    <PublicPolicyDirectoryFilters
                        appliedFilters={appliedFilters}
                        applyFilters={applyFilters}
                    />
                </ModalBody>
            </Modal>
            
            {/* Download Reason Modal */}
            <Modal
                isOpen={modalReason}
                toggle={() => setModalReason(false)}
            >
                <ModalHeader>
                    Select your research goal
                </ModalHeader>
                <ModalBody>
                    <Form>
                       <FormGroup className="mb-3">
                            <Label for="interestGroup" className="mb-1">Organization / Institution / Interest</Label>
                            <Input
                                type="select"
                                id="interestGroup"
                                value={intention.interest_group_id || ""}
                                onChange={(e) => setIntention((prev) => ({ ...prev, interest_group_id: e.target.value ? parseInt(e.target.value) : null }))}
                            >
                               <option value="" disabled hidden>
                                    -- Select Interest Group --
                                </option>
                                {interestGroups.map((group) => (
                                    <option key={group.id} value={group.id}>
                                        {group.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label for="reason" className="mb-1">Reason</Label>
                            <Input
                                type="select"
                                id="reason"
                                value={intention.reason_id || ""}
                                onChange={(e) => setIntention((prev) => ({ ...prev, reason_id: e.target.value ? parseInt(e.target.value) : null }))}
                            >
                               <option value="" disabled hidden>
                                    -- Select Reason --
                                </option>
                                {reasons.map((reason) => (
                                    <option key={reason.id} value={reason.id}>
                                        {reason.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter className="flex flex-col sm:flex-row gap-2 p-4">
                    <Button 
                        className="text-xs md:text-sm py-1 px-3 md:py-2 md:px-4 rounded-full bg-white text-black border border-gray-300 w-full"
                        onClick={() => setModalReason(false)}>
                        Cancel
                    </Button>
                    <Button 
                        className="text-xs md:text-sm py-1 px-3 md:py-2 md:px-4 rounded-full bg-[#036F36] text-[#FFF605] w-full"
                        type="submit" 
                        onClick={saveReasonsAndDownload}>
                        Download Policy File PDF
                    </Button>
                </ModalFooter>
            </Modal>
            
            {/* Policy Preview Modal */}
            <Modal 
                isOpen={modalPreview} 
                toggle={togglePreviewModal} 
            >
                <ModalHeader toggle={togglePreviewModal}>Policy Details</ModalHeader>
                <ModalBody>
                    {policyPreview?.details ? (
                        <div className="max-h-96 overflow-y-auto">
                            <p>{policyPreview.details}</p>
                        </div>
                    ) : (
                        <p>No details available for this policy.</p>
                    )}
                </ModalBody>
            </Modal>
            
            {/* Data Table */}
            <div className="overflow-x-auto">
                {loading ? (
                    <div className="text-center py-8">
                        <LoadingSpinner/>
                        <p className="mt-2">Loading policies...</p>
                    </div>
                ) : (
                    <Table className="table table-bordered border-success mb-0 table-striped" responsive>
                        <thead>
                            <tr>
                                <th className="col-w-lg align-top fix-col">Policy Name</th>
                                <th className="col-w-md align-top fix-col-1">Country</th>
                                <th className="col-w-sm align-top">Policy Type</th>
                                <th className="col-w-sm align-top">Policy Scope</th>
                                <th className="col-w-md align-top">Systems</th>
                                <th className="col-w-md align-top">Implementation Status</th>
                                <th className="col-w-sm align-top">Publication Year</th>
                                <th className="col-w-sm align-top">Registration Number</th>
                                <th className="align-top text-center col-w-md">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.length > 0 ? (
                                data.map((row, i) => (
                                    <tr key={i}>
                                        <td className="col-w-lg text-break fix-col">{row.name.replaceAll('_', ' ')}</td>
                                        <td className="col-w-md fix-col-1">{row.country.long_name}</td>
                                        <td className="col-w-sm">{row.policy_type?.name}</td>
                                        <td className="col-w-sm">{row.policy_scope}</td>
                                        <td className="col-w-md">
                                            {row.policy_systems.map((system, i) => (
                                                <div key={i}>{system.system.name}</div>
                                            ))}
                                        </td>
                                        <td className="col-w-md">{row.implementation_status}</td>
                                        <td className="col-w-sm">{row.publication_year}</td>
                                        <td className="col-w-sm">{row.registration_number}</td>
                                        <td className="text-center col-w-md">
                                            {row.policy_file && 
                                                <div className="flex flex-col sm:flex-row gap-2 justify-center">
                                                    <Button
                                                        color="primary"
                                                        outline
                                                        size="sm"
                                                        onClick={() => {
                                                            setPolicyPreview(row);
                                                            setModalPreview(true);
                                                        }}
                                                    >
                                                        <span className="hidden sm:inline">Preview</span>
                                                        <i className="sm:hidden mdi mdi-eye"></i>
                                                    </Button>
                                                    <Button
                                                        color="primary"
                                                        size="sm"
                                                        onClick={() => { 
                                                            setDownloadingPolicy(row.id); 
                                                            setModalReason(true);
                                                        }}
                                                    >
                                                        <span className="hidden sm:inline">Download</span>
                                                        <i className="sm:hidden mdi mdi-download"></i>
                                                    </Button>
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center py-4">
                                        {searchTerm || areAnyFiltersSelected() ? 
                                            "No policies match your search criteria" : 
                                            "No policies available"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                )}
            </div>
            
            {/* Pagination */}
            <div className="mt-4 flex flex-col md:flex-row md:justify-between">
                <Pagination
                    currentPage={currentPage}
                    goToPage={handlePageChange}
                    totalEntries={totalEntries}
                />
            </div>
            
            <PolicyChatbot />
        </div>
    )
}